export const deviceTypes = Object.freeze({
    MOBILE: 'mobile'
});

export const qualificationTypes = Object.freeze({
    REGIONAL: 'Regional',
    FINAL: 'Final'
});

export const R1_TEE_TIME = 'r1TeeTime';
export const R2_TEE_TIME = 'r2TeeTime';
